import React, { useState, useEffect } from 'react'
import { useOidc, withOidcSecure } from '@axa-fr/react-oidc'
import { width } from "../CustomComponents/Card/CardStyles";
import { useTranslation } from 'react-i18next';
import HomeLayout from '../Layout/HomeLayout';
import DynamicCard from '../CustomComponents/DynamicHomeCard';
import { useNavigate } from 'react-router';
import FooterContent from '../CustomComponents/Footer';
import { clearStorageExceptKey, SecuritySidebar } from '../../utils';
import { useSelector, useDispatch } from 'react-redux';
import { appTheme, fetchConfigarationData, retrieveData } from '../../helpers/utils/Utils';
import Loader from '../CustomComponents/Loader';
import TwoFactTypeSelctionModal from '../CustomComponents/TwoFactTypeSelctionModal';
import { END_SESSION, GENERATE_OTP_CHANGE_PASSWORD, IDOLOGY_STATUS, IDOLOGY_STATUS_SMIONE, STATUS_SUCCESS_CODE } from '../../network/URLConstants';
import logFirebaseEvents from '../LogFirebaseEvents';
import rightArrowDisable from '../../assets/images/right-arrow-disable.png'
import rightArrow from '../../assets/images/right-arrow-enable.png'
import About from '../OnBoard/About';
import Oops from '../../assets/images/Oops.png';
import RadioButtons from '../../kudzu_plus/Kudzu_Plus_Components/RadioButtons';
import CustomAlertModel from '../CustomComponents/CustomAlertModel';
import IdologyLayout from '../Layout/IdologyLayout';
import { GetApiHeadersWithBearer, GetApiHeadersWithOutBearer, GetRequest } from '../../network/NetworkUtils';
import CustomRadioButtonGroup from '../CustomComponents/CustomRadioButton';
import { store } from '../../Redux/store';
import { useLocation } from 'react-router';

const appConfigData = await fetchConfigarationData();
 
const IDology = () => { 
 
    const location = useLocation();
    const isFromOnboard = location.state?.fromOnboard;
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const signUpkudzuPlusTrue = useSelector(state => state.isSignUpKudzuplusTrue);
   
    const appThemeData = appTheme(kudzuPlusTrue  ? kudzuPlusTrue :  signUpkudzuPlusTrue )
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { logout, login } = useOidc();
   
    const twoFactAuthenticationDone = useSelector(state => state.twoFactAuthenticationDone);
    const [selectedType, setSelectedType] = useState('');
    const [isOTPVerifyModalOpen, setIsOTPVerifyModalOpen] = useState(false);
    const accessTokenToApi = useSelector(state => state.accessToken);
    const cardDetails = useSelector(state => state.selectedCardDetails);
    const userId = useSelector(state => state.userId);
    const cards = useSelector(state => JSON.parse(state.userCards));
    const [isLoading, setIsLoading] = useState(false);
    const [Proc, setProc] = useState('');
    const [localErrorMessage, setLocalErrorMessage] = useState('');
    const [modelImage, setModelImage] = useState('')
    const [highlightMsg, setHighlightMsg] = useState('')
    const [headerMsg, setheaderMsg] = useState('')
    const [subHeaderMsg, setSubHeaderMsg] = useState('')
    const [btn1Exists, setBtn1Exists] = useState(false)
    const [btn2Exists, setBtn2Exists] = useState(false)
    const [btn1Text, setBtn1Text] = useState(false)
    const [btn2Text, setBtn2Text] = useState('')
    const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
    const [footerMsg, setFooterMsg] = useState('');
    const [toNavigate, setToNavigate] = useState('');
    const [isBorderNone, setisBorderNone] = useState(true);
    const [showErrorImg, setshowErrorImg] = useState(false);
    const [showModel, setShowModel] = useState(false);

    // Set page title
    useEffect(() => {
        document.title = t("page_title_identity_verification");
    }, [t]);


    const isB2c = useSelector(state => state.preferredIdentity);
    const isFromSmiOne = useSelector((state) => state.fromSmiOne);
    
    


   
    // const isKBAAvailable = useSelector((state) =>state.cipFlowResp?.isKBAAvailable);
    // const cipFlow = useSelector((state) => state.cipFlow);
 
    // const [isOtherDisabled, setIsOtherDisabled] = useState(isKBAAvailable === true);
 
    // const procArray = [
    //     { displayText: t("other"), disabled: isOtherDisabled },
    //     { displayText: t("upload_photo") }
    // ];
   
   
    const isKBAAvailable = useSelector((state) => state.cipFlowResp?.isKBAAvailable);
    const isOtherDisabled = useSelector((state) => state.isOtherDisabled);
    const registerKBA = useSelector((x) => x.registrationKBA)
 

 
    useEffect(() => {
        if (isOtherDisabled === undefined) {
                debugger
           if(isFromOnboard)
           {
        
               dispatch({
                   type: 'SET_OTHER_DISABLED_STATE',
                   payload: registerKBA === false
               });
           }else{
            dispatch({ type: 'SET_OTHER_DISABLED_STATE', payload: userId ? registerKBA === false : isKBAAvailable === false });
           }
        }
    }, [dispatch, isKBAAvailable, isOtherDisabled]);
 
    const procArray = [
        { displayText: t("other"), disabled: isOtherDisabled },
        { displayText: t("upload_photo") }
    ];
 
    // const HighlightMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal  text-[#94C3E8] cursor-pointer";
    // const HeaderMsgStyles = "font-serif-pro text-[#FFFFFF] modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal cursor-pointer";
    // const SubHeaderMsgStyles = "font-hanken-grotesk text-[#FFFFFF] modal-title lg:text-[14px] md:text-[13px] sm:text-[11px] text-[12px] font-normal cursor-pointer pointer-events-none";
    const HighlightMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[var(--modal-text-highlight)]";
    const HeaderMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[var(--modal-text-heading-clr)]";
    const SubHeaderMsgStyles = "font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal text-[var(--modal-text-heading-clr)]";
    const setProcFunction = (value) => {
        debugger;
        setLocalErrorMessage('');
        setSelectedType(value.displayText == t("other") ? 'KBA' : 'SCAN' )
        setProc(value.displayText)
    }
 
 
 
    const handleNext = () =>{
        if (Proc === t("other")) {
            dispatch({ type: 'SET_OTHER_DISABLED_STATE', payload: true });
        }
        apiCall()
        // if(Proc == t("upload_photo") ){
        //     showAlertModal(true, t("heads_up"), t("about_to_leave_kudzu"), t("redirected_from_kudzu"), true, true, t("continue"), t("cancel"), true, '', false, false)
        // }
        // else{
        //     apiCall()
        // }
    }
 
    const apiCall = async () =>{
        setIsLoading(true)
        setShowModel(false)
        // const deviceId = await retrieveData('updatedDeviceId');
        // const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
        const deviceId = await retrieveData('updatedDeviceId');
        if(userId){
        var headers = await GetApiHeadersWithOutBearer(deviceId);
        }
        else{
        var headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);  
        }

        if(isFromSmiOne){
        var  URL = IDOLOGY_STATUS_SMIONE(userId,selectedType)
         
        }else{
        var  URL = IDOLOGY_STATUS(userId,selectedType)
        }

        var response = await GetRequest(URL, headers)
        let responseObj = JSON.parse(response);
        if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
            setIsLoading(false)
            if(Proc == t("other") ){
                const idoloyResponsePayload = { idoloyResponse: responseObj.Response }
                dispatch({ type: 'IDOLOGY_RESPONSE', payload: idoloyResponsePayload });
                navigate('/securityQuestion')
            }
            else{
                const idoloyResponsePayload = { idoloyResponse: responseObj.Response }
                dispatch({ type: 'IDOLOGY_RESPONSE', payload: idoloyResponsePayload });
                navigate('/securityQuestion')
            }
        } else {
             setTimeout(() => {
                setIsLoading(false)
            }, 500);
            var arrMessages = responseObj.Messages;
            var message = arrMessages[0];
            var displayText = message.DisplayText;
            showAlertModal(true, t("oops_exclamation"), '', displayText, true, true, t('home'), t('login'), true, require('../../assets/images/warning.png'), '', false, false, true, false)
            setTimeout(() => {
                //showAlertModal(translate('alert'), '', displayText, translate('alert_ok'), '', require('../../assets/images/alert_warn.png'))
            }, 1000);
        }
    }
    const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, showErrorImg, isBorderNone) => {
        setshowErrorImg(showErrorImg)
        setisBorderNone(isBorderNone)
        setShowModel(showModel)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
    }
    const closeCustomAlertModal = () => {
        setShowModel(false);
    }
 
    const onAcptBtnClick = async () => {
        // if(subHeaderMsg ==  t("redirected_from_kudzu")){
        //     apiCall()
        // }
    }
    const onCancelBtnClick = () => {
       
    }
 
    const handleLogout = async () => {
        // if (!global.isLoggedIn) {
        //   return
        // }
        global.isLoggedIn = false
        await logout()
        logoutManually();
        const deviceIdKey = 'updatedDeviceId';
        clearStorageExceptKey(sessionStorage, deviceIdKey);
        clearStorageExceptKey(localStorage, deviceIdKey);
        dispatch({ type: 'FROM_SMI_ONE', payload: { fromSmiOne: false} })
        store.dispatch({ type: 'LOGOUT' });
        const loginPayload = { isLoggedIn: false };
        dispatch({ type: 'LOG_IN', payload: loginPayload });
        
 
    }
    const logoutManually = async () => {
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
        var url = END_SESSION(isB2c, appConfigData.AUTH_URL, appConfigData.B2C_END_SESSION_URL, appConfigData.CLIENT_ID, accessTokenToApi, appConfigData.POST_LOGOUT_REDIRECT_URI);
        window.location.replace(url);
    }
 
    return (
        <>
            <IdologyLayout>
            <div className='sm:px-[6%] md:py-10 sm:py-12 flex flex-wrap sm:flex-nowrap'>
                <div className='lg:w-[260px] md:w-[290px] w-[185px] sm:mx-0 ml-[2.5rem]'>
                    <p className="text-white font-normal
        lg:text-[31px] md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px] md:leading-[33px]
        sm:leading-[30px] leading-[31px]
         font-serif-pro lg:pb-14 md:pb-[50px] sm:pb-[2.6rem] pb-[2.6rem] mb-10">
                        {t("requires_additional_steps")}
                    </p>
                </div>
                <div className='md:w-[150px] sm:w-[70px] w-[0px]'></div>
 
                <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%]
      animate__animated animate__fadeInRight '>
                    <DynamicCard
                        header={false}
                        CardRadius={true}
                        isWhiteForSignup={appThemeData.isWhiteBgForCard}
                        isDarkForKudzu={appThemeData.isDarkBgForCard}
                        // backgroundColor={'--cardHeading-bg'}
                        cardWidth={width.allpolicies}
                        HeaderRadius={true}
                        HeaderContent={false}>
                        <div className='md:py-20 sm:py-12 py-12 sm:mx-0 mx-4'>
                            <div className='flex-col justify-center sm:mx-0 mx-4'>
                                <div className='w-full flex justify-center'>
                                    <div className='sm:w-[70%] md:w-[70%] w-full sm:leading-[16px] leading-[24px] font-hanken-grotesk font-[500]'>
                                        <div className='font-serif-pro text-[var(--idology-text-color)]
                                   lg:text-[32px] md:text-[30px] sm:text-[22px] text-[25px]
                                    font-normal leading-[38px]'>{t("identity_verification")}</div>
 
                                        <div class="flex sm:w-full flex-col  text-[var(--idology-text-color)]  md:text-[20px] sm:text-[12px]
                                         text-[14px] my-5 font-hanken-grotesk sm:font-[500] font-[400] md:leading-[30px]
                                          sm:leading-[18px] leading-[20px] sm:mx-0 mx-4">
                                            {t("verify_yourself")}
                                        </div>
 
                                        <div class="flex flex-row w-full justify-between mt-20 mb-40">
                                                <div class="flex flex-col mb-5 sm:mb-0 gap-4 w-full mt-3">
                                                    <div class="flex flex-row justify-start items-start gap-1 sm:gap-4">
                                                    <CustomRadioButtonGroup isRowOnMobileSrn={true} title={''} options={procArray} selectedValue={Proc} onSelect={setProcFunction} />
                                                    </div>
                                                </div>
                                        </div>
                                        {localErrorMessage != "" && <div className="flex sm:mx-0 flex-row gap-4 justify-start mt-8 mb-28">
                                            <img src={Oops} alt="" className="md:w-[20px] md:h-[20px] sm:w-[14px]
                                                sm:h-[14px] w-[15px] h-[15px] mt-1 sm:mt-0 md:mt-1  self-start" />
                                                                                    <p className={`font-hanken-grotesk font-[500] text-[16px]  
                                            leading-[24px] md:text-[18px] md:leading-[28px] sm:text-[12px]
                                            sm:leading-[18px] text-white `}>
                                                                                        <span className="text-[#30BC89] font-[600]
                                                lg:font-[600]"> Oops! </span>{localErrorMessage}</p>
                                        </div>}
 
                                        <div className='lg:pt-20 md:pt-18 sm:pt-10 py-16 w-full'>
                                            <div className='flex justify-between w-full'>
 
                                                {/* with disable   */}
                                                <button
                                        type="button"
                                        className="font-hanken-grotesk sm:font-semibold font-[700]  lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]  text-[var(--modal-text-highlight)]  flex items-center"
                                        onClick={() => {
                                            debugger;
                                            if (accessTokenToApi == undefined || accessTokenToApi == null || accessTokenToApi == '') {
                                                navigate('/')
                                                dispatch({ type: 'FROM_SMI_ONE', payload: { fromSmiOne: false} })
                                            } else {
                                                handleLogout()
                                            }
                                        }} >
                                        {t('add_later')}
                                    </button>
 
                                              {Proc == "" && <button
                                                    type="button"
                                                    className={`font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] cursor-pointer flex items-center text-[#94C3E8]`}>
                                                    {t('next')}
                                                    <img src={rightArrowDisable} className={`md:w-[14px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[14px] mt-[2px] h-[14px] ml-1`} alt="" />
                                                </button>}
 
                                                {/* with out disable */}
 
                                                {Proc && <button
                                                    type="button"
                                                    onClick={handleNext}
                                                    className={`font-hanken-grotesk mt-[2px] sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] cursor-pointer flex items-center text-[var(--transactions-filter-blue-text)] `}>
                                                    {t('next')}
                                                    <img src={appThemeData.arrowWhiteTwofac} className="md:w-[14px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[14px] h-[14px] ml-1" alt="" />
                                                </button>}
                                            </div>
                                        </div>
 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </DynamicCard>
                </div>
            </div>
                {/* <About /> */}
                {/* <p className='text-white'>niha</p> */}
            </IdologyLayout>
            <CustomAlertModel isOpen={showModel}
                Fullheight={true}
                // modalBg={'bg-[#262B3A]'}
                // overLayBg={'bg-[#324261]'}
                onClose={closeCustomAlertModal}
                image={modelImage}
                highlightMsg={<p className={HighlightMsgStyles}>{highlightMsg}</p>}
                HeaderMsg={<p className={HeaderMsgStyles}>{headerMsg}</p>}
                subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
                btn1Exists={btn1Exists}
                btn2Exists={btn2Exists}
                btn1Text={btn1Text} btn2Text={btn2Text}
                btn1TypeAcpt={btn1TypeAcpt}
                verificationFailure={() => { }}
                footerMsg={<p className={SubHeaderMsgStyles}>{footerMsg}</p>}
                onAcptBtnClick={onAcptBtnClick}
                onCancelBtnClick={onCancelBtnClick}
                showErrorImg={showErrorImg}
                isBorderNone={isBorderNone}
                kudzuPlusTrue={kudzuPlusTrue}
            />
            {isLoading && <Loader />}
 
        </>
 
    )
}
 
// export default withOidcSecure(IDology)
export default IDology